import { ApiReceivingLogRow } from "./ApiReceivingLogRow";
export class ReceivingLogRow {
    id?: number;
    vendor?: string;
    jobNumber?: string;
    jobName?: string;
    jcDept?: string;
    poNumber?: string;
    items?: string;
    email?: string;
    quantity?: string;
    location?: string;
    dateIn?: string;
    dateOut?: string;
    takenBy?: string;
    shopFloorSF?: number;
    shipmentType?: string;
    loggedBy?: string;
    checkedOut?: boolean;
    notes?: string;
    storageFacility?: string;

    public constructor(init?: Partial<ReceivingLogRow>) {
      if (init) {
        // Safely assign properties to this instance
        Object.assign(this, init);
  
        // Convert Date objects to strings in the MM/DD/YYYY format
        if (init.dateIn) {
        const realDateIn = new Date(init.dateIn);
          this.dateIn = realDateIn.toLocaleDateString('en-US',
           { year: '2-digit',  // Two-digit year
            month: '2-digit', // Two-digit month
            day: '2-digit'    // Two-digit day
          });
        }
         
          if (init.dateOut) {
            const realDateIn = new Date(init.dateOut);
              this.dateOut = realDateIn.toLocaleDateString('en-US',
               { year: '2-digit',  // Two-digit year
                month: '2-digit', // Two-digit month
                day: '2-digit'    // Two-digit day
              });
  }
}
    }
  }
  